var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCall(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.4994 0.620292L48.7105 1.75486C50.54 1.95813 51.9533 3.40336 51.8138 5.2388C51.3966 10.7286 48.8854 22.7346 35.9299 35.6901C22.9745 48.6455 10.9667 51.1587 5.47584 51.5769C3.64007 51.7168 2.19437 50.3033 1.99105 48.4735L0.856573 38.2631C0.683261 36.7033 1.45322 35.1896 2.81593 34.4112L10.3391 30.1134C11.88 29.2332 13.8194 29.493 15.0742 30.7478L17.645 33.3186C18.5755 34.2491 19.9138 34.6435 21.1203 34.1182C22.9078 33.3397 25.7287 31.7492 28.8571 28.6208C31.9855 25.4924 33.576 22.6715 34.3544 20.884C34.8798 19.6776 34.4854 18.3392 33.5549 17.4087L30.9841 14.8379C29.7293 13.5831 29.4694 11.6437 30.3497 10.1028L34.6474 2.57965C35.4259 1.21694 36.9396 0.446981 38.4994 0.620292Z",
    fill: "#434343"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCall);
export default __webpack_public_path__ + "static/media/call.cc6909be3f643f12b299218d0cc462f4.svg";
export { ForwardRef as ReactComponent };